var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-extension main-menu settings-menu"},[_c('main-menu-grouping')],1)}
var staticRenderFns = []

export { render, staticRenderFns }